import(/* webpackMode: "eager" */ "/var/www/turivana/frontend/src/app/[locale]/legal/privacidad/page.tsx");
